<template>
    <div class="myAppointmentBox">
        <div class="titleDiv">
            <span class="lf titleColor"></span>
            <p class="lf titleP">我的预约</p>
        </div>
        <!--查询条件-->
        <div class="searchBox">
            <div class="clearFloat">
                <div class="lf">
                    <span class="lf">预约号</span>
                    <Input class="lf myInput" v-model="selectObj.orderNum" placeholder="请输入预约号" style="width: 250px" />
                </div>
                <div class="rf">
                    <span class="lf">预约类型</span>
                    <Select clearable class="lf mySelect" v-model="selectObj.orderType" style="width:250px">
                        <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </div>
            </div>
            <div class="clearFloat">
                <div class="lf">
                    <span class="lf">预约状态</span>
                    <Select clearable class="lf mySelect" v-model="selectObj.orderState" style="width:250px">
                        <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </div>
                <div class="rf">
                    <span class="lf">预约时间</span>
                    <DatePicker v-model="date" @on-change="date=$event" format="yyyy-MM-dd" class="lf myDatePicker" type="date" placeholder="请输入预约时间" style="width: 250px"></DatePicker>
                </div>
            </div>
            <div class="clearFloat">
                <div class="rf">
                    <Button class="myBtn" type="primary" icon="ios-search" @click="getMyOrderList">查询</Button>
                </div>
            </div>
        </div>
        <!--table-->
        <div class="tableDiv">
            <div class="topBtnsDiv">
                <div class="chBtn" @click="cancle">取消预约</div>
            </div>
            <Table :columns="columnsSq" :data="sqData" :height="tableHeight" @on-selection-change="selectItem">
                <template slot-scope="{ row }" slot="status">
                    <span class="showDeteilsBtn">{{row.orderState==0?'未预约':'已预约'}}</span>
                </template>
            </Table>
            <div class="tablePage" style="height:40px;margin:22px 20px 10px 0;">
                <div style="float: right;margin-right:0%;">
                    <Page :total="dataCount"
                        :page-size="pageSize"
                        class="paging"
                        show-total
                        show-sizer
                        :page-size-opts="pageSizeOpts"
                        @on-change = "changePage"
                        @on-page-size-change = "changePageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getMyOrder,cancleById} from "@/api/userCenter.js"
    import {getUsIdent} from "@/utils/auth";
    import $ from 'jquery/dist/jquery'
    export default {
        name: "myAppointment",
        data(){
            return{
                selectObj:{
                    orderNum:'',
                    orderType:'',
                    orderState:'',
                    orderUserId:getUsIdent(),
                },
                date:'',
                typeList:[
                    {
                        value: '业务类型1',
                        label: '业务类型1'
                    },
                    {
                        value: '业务类型2',
                        label: '业务类型2'
                    }
                ],
                statusList:[
                    {
                        value: 1,
                        label: '已预约'
                    },
                    {
                        value: 0,
                        label: '未预约'
                    }
                ],
                tableHeight:'',
                columnsSq: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '预约号',
                        width: 90,
                        key: "orderNum"
                    },
                    {
                        title: '预约类型',
                        key: 'orderType',
                    },
                    {
                        title: '预约办理时间',
                        key: 'orderTimeFrame'
                    },
                    {
                        title: '预约网点',
                        key: 'addId'
                    },
                    {
                        title: '预约时间',
                        key: 'orderDate'
                    },
                    {
                        title: '预约状态',
                        key: 'orderState',
                        slot:'status'
                    }
                ],
                sqData: [],
                chooseRow:[],
                // 初始化信息总条数
                dataCount: 0,
                // 每页显示多少条
                pageSize: 10,
                // 当前页码
                page: 1,
                pageSizeOpts: [10, 20, 30, 40],
            }
        },
        methods:{
            selectItem(item){
                this.chooseRow = item;
            },
            getMyOrderList(){
                return new Promise((resolve, reject) => {
                    let params = {
                        date:this.date,
                        pageNum:this.page,
                        pageSize:this.pageSize,
                        orderNum:this.selectObj.orderNum,
                        orderType:this.selectObj.orderType,
                        orderState:this.selectObj.orderState,
                        orderUserId:getUsIdent(),
                    }
                    getMyOrder(params).then(resp => {
                        if (resp.data.status === 0) {
                            let result = resp.data.data;
                            this.sqData = result.records;
                            this.dataCount = result.total;
                        }
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
                })
            },
            cancle(){
                if(this.chooseRow.length==0 || this.chooseRow.length>1){
                        this.$Message.error("请勾选且仅勾选一条数据")
                }else{
                    if(this.chooseRow[0].orderState === 0){
                        this.$Message.error("该数据未预约，无法取消")
                    }else{
                        this.cancleMyOrder();
                    }
                }
            },
            cancleMyOrder(){
                return new Promise((resolve, reject) => {
                    let params = {
                        orderId:this.chooseRow[0].orderId
                    }
                    cancleById(params).then(resp => {
                        if (resp.data.status === 0) {
                            this.$Message.success('预约已取消');
                            this.getMyOrderList();
                        }else{
                            this.$Message.success('取消预约失败');
                        }
                        resolve();
                    }).catch(error => {
                        reject(error);
                    });
                })
            },
            changePage(num){
                this.page = num;
                this.getMyOrderList();
            },
            changePageSize(num){
                this.pageSize = num;
                this.getMyOrderList();
            },
        },
        mounted() {
            this.getMyOrderList();
            let heightNum= $(".tableDiv").height() - 110;
            this.tableHeight = heightNum;
            window.addEventListener('resize', () => {
                let heightNum1= $(".tableDiv").height() - 110;
                this.tableHeight = heightNum1;
            }, false)
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../../static/css/common.less");
    .showDeteilsBtn{
        font-size: 16px;
        color: #4AA4FF;
        cursor: pointer;
    }
    .myAppointmentBox{
        width:100%;
        height:100%;
        padding: 17px 5px 0 5px;
        box-sizing: border-box;
        .titleDiv{
            width:100%;
            height:30px;
            margin-bottom:32px;
            .titleColor{
                width:4px;
                height:24px;
                background: #4AA4FF;
                margin: 3px 18px 0 0;
            }
            .titleP{
                font-size: 22px;
                color: @contentTitleColor;
                height:30px;
                line-height:30px;
            }
        }
        .searchBox{
            width:100%;
            padding:16px 23px;
            box-sizing: border-box;
            >div{
                margin-bottom:32px;
            }
            div{
                >span{
                    width:64px;
                    color: @contentCommonColor;
                    font-size: 16px;
                    line-height: 32px;
                    margin-right:16px;
                    margin-top:4px;
                }
                .myInput{
                    height:40px;
                    /deep/ .ivu-input{
                        height:40px;
                    }
                }
                .mySelect{
                    height:40px;
                    /deep/ .ivu-select-selection,/deep/ .ivu-select-placeholder,/deep/ .ivu-select-selected-value{
                        height:40px;
                        line-height: 40px;
                    }
                }
                .myDatePicker{
                    height:40px;
                    /deep/ .ivu-input,/deep/ .ivu-input-suffix i{
                        height:40px;
                        line-height: 40px;
                    }
                }
                .myBtn{
                    width:92px;
                    height:40px;
                    border-radius: 4px;
                    background: #E6A23C;
                    border:0;
                    outline:none;
                }
            }
        }
        .tableDiv{
            width:100%;
            height:625px;
            border-radius: 4px;
            border: 1px solid #E4E7ED;
            padding:40px 24px 32px 24px;
            box-sizing: border-box;
            .topBtnsDiv{
                width:100%;
                height:40px;
                margin-bottom:16px;
                div{
                    height:40px;
                    color: #4AA4FF;
                    line-height:40px;
                    text-align: center;
                    border-radius: 4px;
                    background: #D9ECFF;
                    border: 1px solid #4AA4FF;
                    padding:0 20px;
                    box-sizing: border-box;
                    margin-right:10px;
                    cursor:pointer;
                }
                div.active{
                    color: #fff;
                    background: #4AA4FF;
                }
            }
            .chBtn{
                display: inline-block;
            }
        }

        .tableDiv /deep/ .ivu-table td,.tableDiv /deep/ .ivu-table th{
            /*border:0;*/
            height:48px;
            font-size: 16px;
            color: @contentTitleColor;
        }
        .tableDiv /deep/ .ivu-table th{
            background: #F5F7FA;
        }
        /deep/ .titleSpan{
            width: 500px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .tableDiv /deep/ .ivu-table:before{
            display:none;
        }
        .tableDiv /deep/ .ivu-table-cell,.tableDiv /deep/ .ivu-table-cell>span{
            height:22px !important;
            line-height:22px !important;
            /*padding-left: 0;*/
            padding-right: 0;
        }
        .tableDiv /deep/ .ivu-page-item-active{
             /*background:#027CC3;*/
             background: #4AA4FF;
         }
        .tableDiv /deep/ .ivu-page-item-active a, .tableDiv /deep/ .ivu-page-item-active:hover a{
            color:#fff;
        }
    }
</style>
